import React from 'react'
import * as Styled from './styled'
import { BadgeDto } from 'modules/domain/product/types'

const Badge: React.FC<BadgeDto> = ({ name, urls }) => {
  return <Styled.BadgeImage src={urls.x1} alt={name} title={name} srcSet={`${urls.x1}, ${urls.x2} 2x, ${urls.x3} 3x`} />
}

export default Badge
